// extracted by mini-css-extract-plugin
export var banner = "_hi-0";
export var closeButton = "_hi-2";
export var greenCheckmark = "_hi-3";
export var hereLink = "_hi-4";
export var titleIcon = "_hi-1";